import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '../../lib/utils.js';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'flex h-9 w-full rounded-md border border-[var(--app-divider-2)] bg-[var(--n-0)] px-3 text-body',
        'text-[var(--ink-700)] cursor-pointer',
        '[transition:border-color_var(--dur-hover)_var(--ease-out),box-shadow_var(--dur-hover)_var(--ease-out)]',
        'hover:border-[var(--brand-400)]',
        'focus:outline-none focus-visible:border-[var(--brand-500)] focus-visible:ring-2 focus-visible:ring-[var(--brand-500)]/30',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';
